import { createAction } from "redux-actions";

export const setReadingGroup = createAction("SET_READING_GROUP", id => id);
